export const nationalities = {
  afghan: {
    en: "Afghan",
    ar: "أفغاني",
  },
  albanian: {
    en: "Albanian",
    ar: "ألباني",
  },
  algerian: {
    en: "Algerian",
    ar: "جزائري",
  },
  american: {
    en: "American",
    ar: "أمريكي",
  },
  andorran: {
    en: "Andorran",
    ar: "أندوري",
  },
  angolan: {
    en: "Angolan",
    ar: "أنغولي",
  },
  antiguans: {
    en: "Antiguans",
    ar: "أنتيغوان",
  },
  argentinean: {
    en: "Argentinean",
    ar: "أرجنتيني",
  },
  armenian: {
    en: "Armenian",
    ar: "أرميني",
  },
  australian: {
    en: "Australian",
    ar: "أسترالي",
  },
  austrian: {
    en: "Austrian",
    ar: "نمساوي",
  },
  azerbaijani: {
    en: "Azerbaijani",
    ar: "أذربيجاني",
  },
  bahamian: {
    en: "Bahamian",
    ar: "باهامي",
  },
  bahraini: {
    en: "Bahraini",
    ar: "بحريني",
  },
  bangladeshi: {
    en: "Bangladeshi",
    ar: "بنغلاديشي",
  },
  barbadian: {
    en: "Barbadian",
    ar: "باربادوسي",
  },
  barbudans: {
    en: "Barbudans",
    ar: "باربودي",
  },
  batswana: {
    en: "Batswana",
    ar: "بوتسواني",
  },
  belarusian: {
    en: "Belarusian",
    ar: "بيلاروسي",
  },
  belgian: {
    en: "Belgian",
    ar: "بلجيكي",
  },
  belizean: {
    en: "Belizean",
    ar: "بليزي",
  },
  beninese: {
    en: "Beninese",
    ar: "بنيني",
  },
  bhutanese: {
    en: "Bhutanese",
    ar: "بوتاني",
  },
  bolivian: {
    en: "Bolivian",
    ar: "بوليفي",
  },
  bosnian: {
    en: "Bosnian",
    ar: "بوسني",
  },
  botswanan: {
    en: "Botswanan",
    ar: "بوتسواني",
  },
  brazilian: {
    en: "Brazilian",
    ar: "برازيلي",
  },
  british: {
    en: "British",
    ar: "بريطاني",
  },
  bruneian: {
    en: "Bruneian",
    ar: "بروناي",
  },
  bulgarian: {
    en: "Bulgarian",
    ar: "بلغاري",
  },
  burkinabe: {
    en: "Burkinabe",
    ar: "بوركيني فاسو",
  },
  burmese: {
    en: "Burmese",
    ar: "ميانماري (بورمي)",
  },
  burundian: {
    en: "Burundian",
    ar: "بوروندي",
  },
  cambodian: {
    en: "Cambodian",
    ar: "كمبودي",
  },
  cameroonian: {
    en: "Cameroonian",
    ar: "كاميروني",
  },
  canadian: {
    en: "Canadian",
    ar: "كندي",
  },
  cape_verdean: {
    en: "Cape Verdean",
    ar: "كاب فيردي (الرأس الأخضر)",
  },
  central_african: {
    en: "Central African",
    ar: "وسط أفريقي (جمهورية أفريقيا الوسطى)",
  },
  chadian: {
    en: "Chadian",
    ar: "تشادي",
  },
  chilean: {
    en: "Chilean",
    ar: "شيلي (تشيلي)",
  },
  chinese: {
    en: "Chinese",
    ar: "صيني (صين)",
  },
  colombian: {
    en: "Colombian",
    ar: "كولومبي (كولومبيا)",
  },
  comoran: {
    en: "Comoran",
    ar: "جزر القمر (جزر القمر)",
  },
  congolese: {
    en: "Congolese",
    ar: "كونغولي (الكونغو)",
  },
  costa_rican: {
    en: "Costa Rican",
    ar: "كوستاريكي (كوستاريكا)",
  },
  croatian: {
    en: "Croatian",
    ar: "كرواتي (كرواتيا)",
  },
  cuban: {
    en: "Cuban",
    ar: "كوبي (كوبا)",
  },
  cypriot: {
    en: "Cypriot",
    ar: "قبرصي (قبرص)",
  },
  czech: {
    en: "Czech",
    ar: "تشيكي (جمهورية التشيك)",
  },
  danish: {
    en: "Danish",
    ar: "دنماركي (الدنمارك)",
  },
  djibouti: {
    en: "Djibouti",
    ar: "دومينيكي",
  },
  dominican: {
    en: "Dominican",
    ar: "دومينيكي",
  },
  dutch: {
    en: "Dutch",
    ar: "هولندي",
  },
  east_timorese: {
    en: "East Timorese",
    ar: "تيموري شرقي",
  },
  ecuadorean: {
    en: "Ecuadorean",
    ar: "إكوادوري",
  },
  egyptian: {
    en: "Egyptian",
    ar: "مصري",
  },
  emirati: {
    en: "Emirati",
    ar: "إماراتي",
  },
  equatorial_guinean: {
    en: "Equatorial Guinean",
    ar: "غيني استوائي",
  },
  eritrean: {
    en: "Eritrean",
    ar: "إريتري",
  },
  estonian: {
    en: "Estonian",
    ar: "إستوني",
  },
  ethiopian: {
    en: "Ethiopian",
    ar: "إثيوبي",
  },
  fijian: {
    en: "Fijian",
    ar: "فيجي",
  },
  filipino: {
    en: "Filipino",
    ar: "فلبيني",
  },
  finnish: {
    en: "Finnish",
    ar: "فنلندي",
  },
  french: {
    en: "French",
    ar: "فرنسي",
  },
  gabonese: {
    en: "Gabonese",
    ar: "غابوني",
  },
  gambian: {
    en: "Gambian",
    ar: "غامبي",
  },
  georgian: {
    en: "Georgian",
    ar: "جورجي",
  },
  german: {
    en: "German",
    ar: "ألماني",
  },
  ghanaian: {
    en: "Ghanaian",
    ar: "غاني",
  },
  greek: {
    en: "Greek",
    ar: "يوناني",
  },
  grenadian: {
    en: "Grenadian",
    ar: "غرينادي",
  },
  guatemalan: {
    en: "Guatemalan",
    ar: "غواتيمالي",
  },
  guinea_bissauan: {
    en: "Guinea-Bissauan",
    ar: "غيني بيساوي",
  },
  guinean: {
    en: "Guinean",
    ar: "غيني",
  },
  guyanese: {
    en: "Guyanese",
    ar: "غياني",
  },
  haitian: {
    en: "Haitian",
    ar: "هايتي",
  },
  herzegovinian: {
    en: "Herzegovinian",
    ar: "هندوراسي",
  },
  honduran: {
    en: "Honduran",
    ar: "هندوراسي",
  },
  hungarian: {
    en: "Hungarian",
    ar: "مجري",
  },
  i_kiribati: {
    en: "I-Kiribati",
    ar: "آيسلندي",
  },
  icelander: {
    en: "Icelander",
    ar: "آيسلندي",
  },
  indian: {
    en: "Indian",
    ar: "هندي",
  },
  indonesian: {
    en: "Indonesian",
    ar: "إندونيسي",
  },
  iranian: {
    en: "Iranian",
    ar: "إيراني",
  },
  iraqi: {
    en: "Iraqi",
    ar: "عراقي",
  },
  irish: {
    en: "Irish",
    ar: "إيرلندي",
  },
  israeli: {
    en: "Israeli",
    ar: "إسرائيلي",
  },
  italian: {
    en: "Italian",
    ar: "إيطالي",
  },
  ivorian: {
    en: "Ivorian",
    ar: "ساحل العاج",
  },
  jamaican: {
    en: "Jamaican",
    ar: "جامايكي",
  },
  japanese: {
    en: "Japanese",
    ar: "ياباني",
  },
  jordanian: {
    en: "Jordanian",
    ar: "أردني",
  },
  kazakhstani: {
    en: "Kazakhstani",
    ar: "كازاخستاني",
  },
  kenyan: {
    en: "Kenyan",
    ar: "كيني",
  },
  kittian_and_nevisian: {
    en: "Kittian and Nevisian",
    ar: "كيتسي ونيفيسي",
  },
  kuwaiti: {
    en: "Kuwaiti",
    ar: "كويتي",
  },
  kyrgyz: {
    en: "Kyrgyz",
    ar: "قيرغيزي",
  },
  laotian: {
    en: "Laotian",
    ar: "لاوسي",
  },
  latvian: {
    en: "Latvian",
    ar: "لاتفي",
  },
  lebanese: {
    en: "Lebanese",
    ar: "لبناني",
  },
  liberian: {
    en: "Liberian",
    ar: "ليبيري",
  },
  libyan: {
    en: "Libyan",
    ar: "ليبي",
  },
  liechtensteiner: {
    en: "Liechtensteiner",
    ar: "ليختنشتايني",
  },
  lithuanian: {
    en: "Lithuanian",
    ar: "ليتواني",
  },
  luxembourger: {
    en: "Luxembourger",
    ar: "لوكسمبورغي",
  },
  macedonian: {
    en: "Macedonian",
    ar: "مقدوني",
  },
  malagasy: {
    en: "Malagasy",
    ar: "مدغشقري",
  },
  malawian: {
    en: "Malawian",
    ar: "مالاوي",
  },
  malaysian: {
    en: "Malaysian",
    ar: "ماليزي",
  },
  maldivan: {
    en: "Maldivan",
    ar: "مالديفي",
  },
  malian: {
    en: "Malian",
    ar: "مالي",
  },
  maltese: {
    en: "Maltese",
    ar: "مالطي",
  },
  marshallese: {
    en: "Marshallese",
    ar: "مارشالي",
  },
  mauritanian: {
    en: "Mauritanian",
    ar: "موريتاني",
  },
  mauritian: {
    en: "Mauritian",
    ar: "موريشي",
  },
  mexican: {
    en: "Mexican",
    ar: "مكسيكي",
  },
  micronesian: {
    en: "Micronesian",
    ar: "ميكرونيزي",
  },
  moldovan: {
    en: "Moldovan",
    ar: "مولدوفي",
  },
  monacan: {
    en: "Monacan",
    ar: "موناكي",
  },
  mongolian: {
    en: "Mongolian",
    ar: "منغولي",
  },
  moroccan: {
    en: "Moroccan",
    ar: "مغربي",
  },
  mosotho: {
    en: "Mosotho",
    ar: "موزمبيقي",
  },
  motswana: {
    en: "Motswana",
    ar: "ناميبي",
  },
  mozambican: {
    en: "Mozambican",
    ar: "موزمبيقي",
  },
  namibian: {
    en: "Namibian",
    ar: "ناميبي",
  },
  nauruan: {
    en: "Nauruan",
    ar: "ناورو",
  },
  nepalese: {
    en: "Nepalese",
    ar: "نيبالي",
  },
  new_zealander: {
    en: "New Zealander",
    ar: "نيوزيلندي",
  },
  nicaraguan: {
    en: "Nicaraguan",
    ar: "نيكاراغوي",
  },
  nigerian: {
    en: "Nigerian",
    ar: "نيجيري",
  },
  nigerien: {
    en: "Nigerien",
    ar: "نيجري",
  },
  north_korean: {
    en: "North Korean",
    ar: "كوري شمالي",
  },
  northern_irish: {
    en: "Northern Irish",
    ar: "إيرلندي شمالي",
  },
  norwegian: {
    en: "Norwegian",
    ar: "نرويجي",
  },
  omani: {
    en: "Omani",
    ar: "عماني",
  },
  pakistani: {
    en: "Pakistani",
    ar: "باكستاني",
  },
  palauan: {
    en: "Palauan",
    ar: "بالاوي",
  },
  palestinian: {
    en: "Palestinian",
    ar: "فلسطيني",
  },
  panamanian: {
    en: "Panamanian",
    ar: "بنمي",
  },
  papua_new_guinean: {
    en: "Papua New Guinean",
    ar: "بابوا غينيا الجديدة",
  },
  paraguayan: {
    en: "Paraguayan",
    ar: "باراغواي",
  },
  peruvian: {
    en: "Peruvian",
    ar: "بيروفي",
  },
  polish: {
    en: "Polish",
    ar: "بولندي",
  },
  portuguese: {
    en: "Portuguese",
    ar: "برتغالي",
  },
  qatari: {
    en: "Qatari",
    ar: "قطري",
  },
  romanian: {
    en: "Romanian",
    ar: "روماني",
  },
  russian: {
    en: "Russian",
    ar: "روسي",
  },
  rwandan: {
    en: "Rwandan",
    ar: "رواندي",
  },
  saint_lucian: {
    en: "Saint Lucian",
    ar: "سانت لوسي",
  },
  salvadoran: {
    en: "Salvadoran",
    ar: "سلفادوري",
  },
  samoan: {
    en: "Samoan",
    ar: "ساموي",
  },
  san_marinese: {
    en: "San Marinese",
    ar: "سان ماريني",
  },
  sao_tomean: {
    en: "Sao Tomean",
    ar: "ساو تومي",
  },
  saudi: {
    en: "Saudi",
    ar: "سعودي",
  },
  scottish: {
    en: "Scottish",
    ar: "اسكتلندي",
  },
  senegalese: {
    en: "Senegalese",
    ar: "سنغالي",
  },
  serbian: {
    en: "Serbian",
    ar: "صربي",
  },
  seychellois: {
    en: "Seychellois",
    ar: "سيشلي",
  },
  sierra_leonean: {
    en: "Sierra Leonean",
    ar: "سيراليوني",
  },
  singaporean: {
    en: "Singaporean",
    ar: "سنغافوري",
  },
  slovakian: {
    en: "Slovakian",
    ar: "سلوفاكي",
  },
  slovenian: {
    en: "Slovenian",
    ar: "سلوفيني",
  },
  solomon_islander: {
    en: "Solomon Islander",
    ar: "جزر سليمان",
  },
  somali: {
    en: "Somali",
    ar: "صومالي",
  },
  south_african: {
    en: "South African",
    ar: "جنوب أفريقي",
  },
  south_korean: {
    en: "South Korean",
    ar: "كوري جنوبي",
  },
  spanish: {
    en: "Spanish",
    ar: "إسباني",
  },
  sri_lankan: {
    en: "Sri Lankan",
    ar: "سريلانكي",
  },
  sudanese: {
    en: "Sudanese",
    ar: "سوداني",
  },
  surinamer: {
    en: "Surinamer",
    ar: "سورينامي",
  },
  swazi: {
    en: "Swazi",
    ar: "سوازي",
  },
  swedish: {
    en: "Swedish",
    ar: "سويدي",
  },
  swiss: {
    en: "Swiss",
    ar: "سويسري",
  },
  syrian: {
    en: "Syrian",
    ar: "سوري",
  },
  taiwanese: {
    en: "Taiwanese",
    ar: "تايواني",
  },
  tajik: {
    en: "Tajik",
    ar: "طاجيكي",
  },
  tanzanian: {
    en: "Tanzanian",
    ar: "تنزاني",
  },
  thai: {
    en: "Thai",
    ar: "تايلاندي",
  },
  togolese: {
    en: "Togolese",
    ar: "توغولي",
  },
  tongan: {
    en: "Tongan",
    ar: "تونغي",
  },
  trinidadian_or_tobagonian: {
    en: "Trinidadian or Tobagonian",
    ar: "ترينيدادي أو توباغوني",
  },
  tunisian: {
    en: "Tunisian",
    ar: "تونسي",
  },
  turkish: {
    en: "Turkish",
    ar: "تركي",
  },
  tuvaluan: {
    en: "Tuvaluan",
    ar: "توفالي",
  },
  ugandan: {
    en: "Ugandan",
    ar: "أوغندي",
  },
  ukrainian: {
    en: "Ukrainian",
    ar: "أوكراني",
  },
  uruguayan: {
    en: "Uruguayan",
    ar: "أوروغواياني",
  },
  uzbekistani: {
    en: "Uzbekistani",
    ar: "أوزبكستاني",
  },
  venezuelan: {
    en: "Venezuelan",
    ar: "فنزويلي",
  },
  vietnamese: {
    en: "Vietnamese",
    ar: "فيتنامي",
  },
  welsh: {
    en: "Welsh",
    ar: "ويلزي",
  },
  yemenite: {
    en: "Yemenite",
    ar: "يمني",
  },
  zambian: {
    en: "Zambian",
    ar: "زامبي",
  },
  zimbabwean: {
    en: "Zimbabwean",
    ar: "زيمبابوي",
  },
};
